module.exports = __webpack_public_path__ + "static/less-than-20-cents-white-ff274cb804d2466a51022b5096707553.png";